<template>
  <div>
    <div class="block__container block__container--compact">
      <step-header-component :headerText="headerText" :subHeaderText="subHeaderText"></step-header-component>
    </div>
    <div class="block--primary">
      <carousel></carousel>
    </div>
    <div class="block__container block__container--compact">
      <progress-bar
        :hideForwardNavigation="hideForwardNavigation"
        :hideBackwardNavigation="true"
        :validationScope="validationScope"
        :progressBarValue=10>
      </progress-bar>
      <vehicle-level-filter :validationScope="validationScope"></vehicle-level-filter>
      <enquiry-choices></enquiry-choices>
      <next-button :validationScope="validationScope"></next-button>
    </div>
    <div class="block--center">
      <pricing-data></pricing-data>
    </div>
    <div class="block--tertiary block--center">
      <div class="block__container block__container--compact">
        <testimonials></testimonials>
      </div>
    </div>
    <div class="block__container">
      <start-again></start-again>
    </div>
    <div class="block--secondary block--center">
      <div class="block__container">
        <accordion></accordion>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  Component, Prop, Vue, Watch
} from 'vue-property-decorator';
import StepHeaderComponent from '../general/StepHeaderComponent.vue';
import CarouselComponent from '../general/CarouselComponent.vue';
import ProgressBarComponent from '../general/ProgressBarComponent.vue';
import EnquiryChoicesComponent from '../enquiry/EnquiryChoicesComponent.vue';
import VehicleLevelFilterComponent from '../vehicle/VehicleLevelFilterComponent.vue';
import NextButtonComponent from '../navigation/NextButtonComponent.vue';
import PricingDataComponent from '../pricing/PricingDataComponent.vue';
import TestimonialsComponent from '../general/TestimonialsComponent.vue';
import StartAgainComponent from '../navigation/StartAgainComponent.vue';
import AccordionComponent from '../general/AccordionComponent.vue';

@Component({
  components: {
  'step-header-component': StepHeaderComponent,
  carousel: CarouselComponent,
  'progress-bar': ProgressBarComponent,
  'enquiry-choices': EnquiryChoicesComponent,
  'vehicle-level-filter': VehicleLevelFilterComponent,
  'next-button': NextButtonComponent,
  'pricing-data': PricingDataComponent,
  testimonials: TestimonialsComponent,
  'start-again': StartAgainComponent,
  accordion: AccordionComponent
  }
  })

export default class VehicleSelectionStepComponent extends Vue {
  @Prop({ default: 'Select your vehicleName' })
  public headerText!: string;

  @Prop({ default: 'Find your perfect make and model' })
  public subHeaderText!: string;

  @Prop({ default: null })
  public validationScope!: string;

  @Prop({ default: false })
  public hideForwardNavigation!: boolean;
}
</script>
